/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "core-js/stable"
import "regenerator-runtime/runtime"

// Turbolinks
import Turbolinks from "turbolinks"
import patchTurbolinksForCsp from "./util/turbolinks_csp"
patchTurbolinksForCsp(Turbolinks)
Turbolinks.start()

// JS dependencies (npm/yarn)
import $ from "jquery"
import "./jquery"
import "jquery-ujs"
import "popper.js"
import "bootstrap/dist/js/bootstrap.bundle.min"
import "bootstrap-switch-button"
import "summernote/dist/summernote-lite.min.js"
import "cocoon-js"
import "flatpickr"
import "select2"
import "select2/dist/css/select2.css"
import "jstree"
import Tagify from "@yaireo/tagify"
import "sweetalert"

// JS dependencies (other external)

import "../libraries/detect-swipe"
import "../libraries/featherlight"
import "../libraries/featherlight-gallery"
import "../libraries/jquery-bar-rating"

// Load SCSS
import "../stylesheets/application"

// Our Code
import "./util/live_preview"
import "./util/modal"
import "./util/tos_modal"
import "./util/passkey_modal"
import "./util/webauthn_forms"
import "./util/staging_placeholder"

import "./components/admin/promos"
import "./components/account/follow_switch"
import "./components/backend_menu/backend_menu"
import "./components/manageui/manageui"
import "./components/chart/highcharts"
import "./components/checkout/checkout"
import "./components/checkout/stripe_checkout"
import "./components/input_date/input_date"
import "./components/input_file/input_file"
import "./components/input_password/show_password"
import "./components/input_select/input_select"
import "./components/input_select/input_user_select"
import "./components/central_catalog_tree/central_catalog_tree"
import "./components/input_slug/input_slug"
import "./components/input_text/input_text"
import "./components/input_text/counted"
import "./components/modal/modal_cart_login"
import "./components/modal/modal_support"
import "./components/modal/modal_youtube"
import "./components/product/bar_rating"
import "./components/product/product_page"
import "./components/product/product_rating_form"
import "./components/product/product_ratings_pagination"
import "./components/product/product_content"
import "./components/product/product_sidebar"
import "./components/product/shop_follow_button"
import "./components/product/variant_pricing"
import "./components/product/add_to_cart_quantity"
import "./components/quantity_stepper"
import "./components/cart/cart_item_quantity"
import "./components/sort/sort"
import "./components/sort/product_grid"
import "./components/swiper_init/swiper"
import "./components/analytics/google_analytics"
import "./components/copy/copy_text"
import "./components/api_token/generate_token"
import "./components/api_token/generate_library_url"
import "./components/api_token/rename_token"
import "./components/account/asset_browse"
import "./components/assets/assets_browse"
import "./components/assets/catalog_scroll"
import "./components/assets/results_swap"
import "./components/assets/quick_look"
import "./components/mailchimp/mailchimp_subscribe_form"
import "./components/search_suggest/search_suggest"
import "./components/whats_selling/whats_selling"

import "./views/account/account"
import "./views/admin/coupons/coupons"
import "./views/admin/orders/orders"
import "./views/admin/payouts/payouts"
import "./views/admin/product_bundles/product_bundle_faqs"
import "./views/admin/product_bundles/product_bundle_form"
import "./views/admin/product_bundles/product_bundle_items"
import "./views/admin/product_bundles/product_bundle_tiers"
import "./views/admin/product_review/product_edit"
import "./views/admin/product_review/flags"
import "./views/admin/products/unlist_confirm"
import "./views/admin/refunds/refunds"
import "./views/admin/sale_campaigns/sale_campaigns"

import "./views/creator/affiliates/creator_affiliates"
import "./views/creator/asset_libraries/assets_table"
import "./views/creator/asset_libraries/catalogs"
import "./views/creator/asset_libraries/products"
import "./views/creator/asset_libraries/upload"
import "./views/creator/emails/emails"
import "./views/creator/reports/events"
import "./views/creator/settings/shop"
import "./views/creator/sitewide_settings"
import "./views/creator/products/categories"
import "./views/creator/products/licenses"
import "./views/creator/products/commission"
import "./views/creator/products/dev_fund"
import "./views/creator/products/edit_product"
import "./views/creator/products/faqs_sortable"
import "./views/creator/products/section_autosave"
import "./views/creator/products/submit_review"
import "./views/creator/products/title_preview"
import "./views/creator/products/variants_page"
import "./views/creator/products/asset_attachments"
import "./views/creator/products/product_asset_uploads"
import "./views/creator/products/asset_migrations"
import "./views/creator/products/version_downloads_sortable"
import "./views/creator/products/version_form"
import "./views/creator/products/webhook_form"
import "./views/creator/products/webhook_resend_form"

import "./views/header/main_menu"
import "./views/header/search"
import "./views/header/user_dropdown"
import "./views/header/creator_dropdown"
import "./views/inbox/read_all_switch"
import "./views/inbox/clickable_rows"
import "./views/inbox/external_link_interstitial"
import "./views/login/login"
import "./views/order/pickup"
import "./views/privacy/privacy"
import "./views/vendor_applications/vendor_applications"
import "./views/affiliate_applications/affiliate_applications"

$(document).on("turbolinks:load", function () {
  // Boootsrap initialization
  $(".alert").alert()
  $('[data-bs-toggle="tooltip"]').tooltip()
  $(".toast").toast("show")

  // Tagify initialization
  var $tagInputs = $(".js-tags")
  if ($tagInputs.length > 0) {
    $tagInputs.each(function (index, el) {
      var $el = $(el)
      var taglist = $el.data("taglist") || []

      new Tagify(el, {
        placeholder: "Tags ...",
        whitelist: taglist,
        delimiters: ",",
      })
    })
  }

  // Tagify initialization for Webhook resend form
  var $orderItemIdInputs = $(".js-order-item-ids")
  if ($orderItemIdInputs.length > 0) {
    $orderItemIdInputs.each(function (index, el) {
      new Tagify(el, {
        placeholder: "Order item IDs ...",
        pattern: /^[0-9]*$/,
        delimiters: ",",
      })
    })
  }

  // Featherlight initialization
  $(".js-product-gallery .swiper-slide a").featherlightGallery({
    previousIcon: "<",
    nextIcon: ">",
    galleryFadeIn: 300,
    openSpeed: 300,
  })

  // Bootstrap switch button initialization
  $('input[data-bs-toggle="switchbutton"]').each(function (index, el) {
    el.switchButton()
  })

  // currency input formatter
  $(".price-in-dollars").on("input", function () {
    let value = $(this).val()
    value = value.replace(/[^0-9.]/g, "")
    if (value.indexOf(".") !== -1) {
      value = value.split(".").slice(0, 2).join(".")
      value = value.replace(/(\..*)\./g, "$1")
    }
    $(this).val(value)
  })

  // disable turbolinks on anchor tags in the Cookiebot Dialog Box
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if ($(node).is("#CybotCookiebotDialog")) {
          $("#CybotCookiebotDialogDetailBodyContentCookieContainerTypes").attr(
            "data-turbolinks",
            "false"
          )
        }
      })
    })
  })

  const targetNode = document.body
  const config = { childList: true, subtree: true }

  observer.observe(targetNode, config)
})
